import AContainer from '../../library/ExtendedObjects/AContainer.js';
import gameData from '../../gameData.js';
import AImage from '../../library/ExtendedObjects/AImage.js';
import ABCyaPhaser from '@abcya/abcya_phaser';
import FontKeys from '../../FontKeys.js';
import ABCyaLib from '@abcya/abcya_lib';

export default class DialoguePopup extends AContainer {
  constructor(scene, step) {
    super(scene);

    this.step = step;

    this.createPopup();
    this.createButton();

    this.tweenInPopup();
  }

  createPopup() {
    this.popupCont = this.scene.add.container();
    this.add(this.popupCont);

    let fSize;
    if (gameData.round === 3) {
      fSize = ABCyaLib.Environment.instance.gameConfig.round3InstructionTextFontSize;
    } else {
      fSize = 24;
    }

    this.bg = new AImage(this.scene, 0, 0, this.scene.defaultAtlas, "InstruxPopup1");
    
    this.popupCont.add(this.bg);
    
    const t = ABCyaPhaser.Localization.instance.getLocalizedString('rivette_dialogue.step_' + (this.step + 1));
    this.txt = ABCyaPhaser.Text.addText(this.popupCont.x - 113, 0, fSize, 0x5e3423, FontKeys._Tertre_Med, t, this.popupCont, false).setWordWrapWidth(545).setOrigin(0, 0.5);
    
    this.txt.y = this.popupCont.y - 218;
    if (this.step === 4) {
      this.bg.setScale(1, .75);
      this.txt.y += this.bg.height*0.25/2;
    }

    this.popupCont.setScale(.5, .5);
    this.popupCont.setPosition(375, this.scene.mid.y + 150);
  }

  createButton() {
    this.btn = this.scene.addButton(550, 600, "NextBtn", {}, () => { this.tweenOutPopup(); });
    this.btn.alpha = 0;
  }

  enableButton() {
    this.btn.setInteractive();
  }

  disableButton() {
    this.btn.disableInteractive();
  }

  tweenInPopup() {
    this.scene.playSound("text_tween");

    this.scene.addTween(this.popupCont, 1000, { scaleX: 1, scaleY: 1 }, Phaser.Math.Easing.Back.Out);
    this.scene.addTween(this.btn, 1000, { alpha: 1 }, Phaser.Math.Easing.None);
  }

  tweenOutPopup() {
    this.scene.playSound("click");
    this.scene.playSound("text_tween");

    this.btn.disableInteractive();
    this.btn.input.enabled = false;

    this.scene.addTween(this.popupCont, 500, { scaleX: 0, scaleY: 0 }, Phaser.Math.Easing.Back.In);
    this.scene.addTween(this.btn, 500, { alpha: 0 }, Phaser.Math.Easing.None,
      () => { this.clearPopup(); });
  }

  clearPopup() {
    if (this.bg) this.bg.destroy();
    if (this.txt) this.txt.destroy();
    if (this.btn) this.btn.destroy();

    if (this.step === 0) {
      this.step++;

      this.createPopup();
      this.createButton();

      this.tweenInPopup();
    }
    else if (this.step === 1 || this.step === 2 || this.step === 3) {
      this.scene.skipStart();
    }
    else if (this.step === 4) {
      this.scene.tweenOutGame('Museum');
    }
  }
}